export const uniforms = {}